module.exports = __webpack_public_path__ + "media/images/Signatures_About-e54470c760134939e89474a6e5699707.jpg";